module.exports = __webpack_public_path__ + "static/media/the-generic-band-1986.93ff63f6.jpg";